import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { TelegramProvider } from "./telegram";
import "./styles.css";
import "./mechanic/index.css";

const router = createBrowserRouter([
  { path: "*", element: <TelegramProvider><App /></TelegramProvider> },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
